import { BackgroundIcon } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import React from 'react';

function SoftwareLogo({
  url,
  height = '20px',
  width = '20px',
  opacity,
  position = 'center',
  noMargin = false
}) {
  return (
    <div className={`${!noMargin ? 'no-margin' : ''}`}>
      {url ? (
        <BackgroundIcon
          url={`url(${url})`}
          height={height}
          width={width}
          position={position}
          opacity={opacity || 1}
        />
      ) : (
        <SVGIcon name="SoftwareBundle" />
      )}
    </div>
  );
}

export { SoftwareLogo };
